import { useGT } from 'gt-react';
import { anchorMetricFieldOptions } from 'src/components/tasks/anchorMetricFields';
import { emptyEditorState, type TaskTypeEditorState } from './taskTypeAdmin';
import {
  effectiveMetricFields,
  type MetricFieldOption,
} from './taskTypeMetricsDraft';
import { useTaskTypeProcedureInput } from './useTaskTypeProcedureInput';

/**
 * The fields the editor's sum cards may total, as the metric cards section
 * shows them, so the Save check rejects the same stale fields. Null while the
 * input schema is unknown.
 */
export function useMetricFieldOptions(
  editor: TaskTypeEditorState | null,
): MetricFieldOption[] | null {
  const gt = useGT();
  const input = useTaskTypeProcedureInput(editor ?? emptyEditorState());
  return effectiveMetricFields(
    input.status,
    input.metricFields,
    anchorMetricFieldOptions(editor?.anchorEntityType, gt),
  );
}
